import React from 'react';
import Zoom from 'react-reveal/Zoom';

const payment = () => {
    return (
        <Zoom>
            <div>
                <h3>Payment system coming soon.</h3>
            </div>
        </Zoom>
    );
};

export default payment;